/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const evaluateInAppRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInApp',
  auth: 'app',
  fingerprint: '6BBtymEgT83fvjBVnAwcMJwP6LXzGzX8',
  na1Only: false
};